/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Polygon } from "./Polygon";
import {
  PolygonFromJSON,
  PolygonFromJSONTyped,
  PolygonToJSON,
  PolygonToJSONTyped,
} from "./Polygon";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface RasterEdit
 */
export interface RasterEdit {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  raster: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   * Absolute or relative height (in meters)  to use for the polygon
   */
  value: number;
  /**
   *
   */
  polygon: Polygon;
  /**
   * Process the value as a relative height, default is absolute
   */
  relative?: boolean;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the RasterEdit interface.
 */
export function instanceOfRasterEdit(value: object): value is RasterEdit {
  if (!("raster" in value) || value["raster"] === undefined) return false;
  if (!("offset" in value) || value["offset"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  if (!("polygon" in value) || value["polygon"] === undefined) return false;
  return true;
}

export function RasterEditFromJSON(json: any): RasterEdit {
  return RasterEditFromJSONTyped(json, false);
}

export function RasterEditFromJSONTyped(json: any, ignoreDiscriminator: boolean): RasterEdit {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    raster: json["raster"],
    offset: json["offset"],
    value: json["value"],
    polygon: PolygonFromJSON(json["polygon"]),
    relative: json["relative"] == null ? undefined : json["relative"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function RasterEditToJSON(json: any): RasterEdit {
  return RasterEditToJSONTyped(json, false);
}

export function RasterEditToJSONTyped(
  value?: Omit<RasterEdit, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    raster: value["raster"],
    offset: value["offset"],
    value: value["value"],
    polygon: PolygonToJSON(value["polygon"]),
    relative: value["relative"],
  };
}
